// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3okIe","boxTitle":"Qualiphy_boxTitle__Xb9b8","box":"Qualiphy_box__1wSlX","toggleWrap":"Qualiphy_toggleWrap__153aH"};